var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WeSelect',{attrs:{"options":_vm.options,"label-prop":"name","small":true,"form-control":false},model:{value:(_vm.computedData),callback:function ($$v) {_vm.computedData=$$v},expression:"computedData"}})}
var staticRenderFns = []

export { render, staticRenderFns }